import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { productService } from '../services/productService';
import { getCountryName } from '../utils/countries';

const ProductViewScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const data = await productService.getProductById(id);
        setProduct(data);
        setLoading(false);
      } catch (err) {
        setError('Error al cargar el producto');
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error">
        <span>{error}</span>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="alert alert-warning">
        <span>Producto no encontrado</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="page-header">
        <h1 className="page-title">{product.name}</h1>
        <div className="page-actions">
          <button 
            onClick={() => navigate(`/products/${id}/edit`)}
            className="btn btn-primary"
          >
            Editar
          </button>
          <button 
            onClick={() => navigate(`/product-stats/${id}`)}
            className="btn btn-secondary"
          >
            Ver Estadísticas
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <div className="card bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title">Información del Producto</h2>
            <div className="space-y-4">
              <div>
                <label className="font-semibold">Nombre:</label>
                <p>{product.name}</p>
              </div>
              <div>
                <label className="font-semibold">Plataforma:</label>
                <p>{product.Platform?.name || 'No especificada'}</p>
              </div>
              <div>
                <label className="font-semibold">URL:</label>
                <p>{product.url || 'No especificada'}</p>
              </div>
              <div>
                <label className="font-semibold">País:</label>
                <p>{getCountryName(product.country) || 'No especificado'}</p>
              </div>
              <div>
                <label className="font-semibold">Ciudad:</label>
                <p>{product.city || 'No especificada'}</p>
              </div>
              <div>
                <label className="font-semibold">Notas:</label>
                <p>{product.notes || 'Sin notas'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductViewScreen; 
